import React, { memo, useEffect, useState, useCallback } from 'react';
import styles from './styles.module.css';
import { Table, Loading } from '../../../../../common/ui';
import { getUsers } from '../../actions';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';

const UserTable = memo(
  ({
    getUsers,
    usersState: { usersData, pagination, isLoading },
    searchKeyword = '',
    branchId,
  }) => {
    const navigate = useNavigate();
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);

    const handleUpdate = useCallback(
      (id) => {
        navigate(`/iam/users/update-user/${id}`);
      },
      [navigate]
    );

    const columns = [
      { id: 'name', label: 'Name', minWidth: 150 },
      { id: 'username', label: 'User Name', minWidth: 150 },
      { id: 'email', label: 'Email', minWidth: 150 },
      { id: 'phone', label: 'Phone', minWidth: 100 },
      { id: 'address', label: 'Address', minWidth: 200 },
      { id: 'role', label: 'Role', minWidth: 100 },
      {
        id: 'options',
        minWidth: 50,
        options: ['Update'],
        customHandlers: { onUpdate: handleUpdate },
      },
    ];

    useEffect(() => {
      getUsers({ page, limit, searchKeyword });
    }, [getUsers, searchKeyword, page, limit, branchId]);

    useEffect(() => {
      setPage(1);
    }, [branchId]);

    const handleChangePage = useCallback((event, newPage) => {
      setPage(newPage + 1);
    }, []);

    const handleChangeRowsPerPage = useCallback((event) => {
      setLimit(parseInt(event.target.value, 10));
      setPage(1);
    }, []);

    const rows = Array.isArray(usersData) ? usersData : [];
    const totalCount = pagination?.totalRecords ?? 0;

    return (
      <div className={styles.mainDiv}>
        {isLoading && <Loading variant="overlay" label="Loading..." />}
        <Table
          columns={columns}
          rows={rows}
          page={page - 1}
          rowsPerPage={limit}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          totalCount={totalCount}
          disableInternalPagination
          emptyMessage="No users found."
        />
      </div>
    );
  }
);

UserTable.propTypes = {
  getUsers: PropTypes.func.isRequired,
  usersState: PropTypes.shape({
    usersData: PropTypes.array,
    pagination: PropTypes.shape({ totalRecords: PropTypes.number }),
    isLoading: PropTypes.bool,
  }),
  searchKeyword: PropTypes.string,
  branchId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

UserTable.defaultProps = {
  usersState: {},
  searchKeyword: '',
  branchId: null,
};

const mapStateToProps = (state) => ({
  usersState: state.usersState,
  branchId: state.authState.branchId,
});

export default connect(mapStateToProps, { getUsers })(UserTable);
